mutation MarkPracticeRecordingListened($id: ID!) {
  markPracticeRecordingListened(id: $id) {
    ok
    errors
  }
}
